import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Deadline from '../../entities/deadline';
export function deleteDeadline(deadline: Deadline, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = deadline.id;}
const _work = workingSet();




deadline.status = 'D';
deadline.addedOn = newHRTimestamp();
deadline.addedBy = getCurrentUserId();
deadline.importSource = targetImportSource;
deadline.importId = mergeId;
store.dispatch(Actions.DeadlineActions.removeDeadlineQueue(deadline));
}


